import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Church, GraduationCap } from 'lucide-react';

const ROLE_COLORS = {
  admin: 'bg-amber-500 text-black',
  pastor: 'bg-indigo-500 text-white',
  worship_leader: 'bg-purple-500 text-white',
  music: 'bg-pink-500 text-white',
  multimedia: 'bg-emerald-500 text-white',
  volunteer: 'bg-sky-500 text-white',
  member: 'bg-slate-500 text-white',
  teacher: 'bg-indigo-500 text-white',
  assistant: 'bg-purple-500 text-white',
  student: 'bg-sky-500 text-white'
};

const ROLE_LABELS = {
  admin: 'Admin',
  pastor: 'Pastor',
  worship_leader: 'Worship Leader',
  music: 'Music Ministry',
  multimedia: 'Multimedia Team',
  volunteer: 'Volunteer',
  member: 'Member',
  teacher: 'Teacher',
  assistant: 'Assistant',
  student: 'Student'
};

const CommunitySidebar = ({ communities, selectedCommunity, onSelectCommunity }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">Your Communities</CardTitle>
      </CardHeader>
      <CardContent className="p-2">
        {communities.map((comm) => (
          <button
            key={comm.community_id}
            onClick={() => onSelectCommunity(comm)}
            className={`w-full p-3 rounded-lg text-left transition-colors ${
              selectedCommunity?.community_id === comm.community_id
                ? 'bg-amber-100 dark:bg-amber-900/30 border-l-4 border-amber-500'
                : 'hover:bg-slate-100 dark:hover:bg-slate-800'
            }`}
            data-testid={`community-item-${comm.community_id}`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                comm.type === 'church' ? 'bg-amber-500' : 'bg-indigo-500'
              }`}>
                {comm.type === 'church' ? (
                  <Church className="w-4 h-4 text-white" />
                ) : (
                  <GraduationCap className="w-4 h-4 text-white" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">{comm.name}</p>
                <Badge className={`text-xs ${ROLE_COLORS[comm.my_role]}`}>
                  {ROLE_LABELS[comm.my_role]}
                </Badge>
              </div>
            </div>
          </button>
        ))}
      </CardContent>
    </Card>
  );
};

export { CommunitySidebar, ROLE_COLORS, ROLE_LABELS };
export default CommunitySidebar;
